import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';
import Navbar from './Navbar';
import menuService from '../services/menuService';

const CategoryMenuPage = () => {
    const { category } = useParams(); // Get the category from the URL
    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Dynamically determine the base URL for the backend
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;

    // Mapping of categories to their respective logo file paths
    const categoryLogos = {
        brunch: `${process.env.PUBLIC_URL}/assets/logos/brunchmenu.png`,
        lunch: `${process.env.PUBLIC_URL}/assets/logos/lunchmenu.png`,
        dinner: `${process.env.PUBLIC_URL}/assets/logos/dinnermenu.png`,
        drinks: `${process.env.PUBLIC_URL}/assets/logos/drinksmenu.png`,
    };

    useEffect(() => {
        const fetchMenuItems = async () => {
            try {
                const items = await menuService.getMenuItems();
                const filteredItems = items.filter(item => item.category === category);
                setMenuItems(filteredItems);
            } catch (err) {
                setError('Failed to load menu items');
            } finally {
                setLoading(false);
            }
        };

        fetchMenuItems();
    }, [category]);

    if (loading) {
        return (
            <>
                <Navbar />
                <CircularProgress />
            </>
        );
    }

    if (error) {
        return (
            <>
                <Navbar />
                <Typography color="error">{error}</Typography>
            </>
        );
    }

    // Styles for the category headers and the main heading
    const headingStyles = {
        fontFamily: "'Brilon', sans-serif", // Use the Old Alfie font
        border: '2px solid #4caf50', // Add a green border
        padding: '20px', // Add padding inside the border
        borderRadius: '8px', // Optional: Add rounded corners
        marginBottom: '20px', // Add spacing below the heading
        textAlign: 'center', // Center the text
        marginTop: '20px'
    };

    return (
        <>
            <Navbar />
            {/* Render the category logo */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '20px',
                    marginBottom: '20px',
                }}
            >
                <img
                    src={categoryLogos[category] || `${process.env.PUBLIC_URL}/assets/logos/default.png`} // Fallback to default logo
                    alt={`${category} logo`}
                    style={{
                        maxWidth: '400px',
                        height: 'auto',
                    }}
                />
            </Box>
            <Grid container spacing={2}>
                {menuItems.map(item => (
                    <Grid item xs={12} sm={6} md={4} key={item.id}>
                        <Card>
                            <CardContent>
                                <img
                                    src={item.image_url}
                                    alt={item.name}
                                    style={{ width: '50%' }}
                                />
                                <Typography variant="h6">{item.name}</Typography>
                                <Typography variant="body2">{item.description}</Typography>
                                <Typography variant="body2">${item.price}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default CategoryMenuPage;